<template>
    <div>
        <div class="list-search-layout">
            <div class="flex flex-cross-center flex-main-center flex-box-1"
                 style="background-color: white; border-radius: 3px; height: 30px"
                 @click="showSearchPop()">
                <img src="../../assets/img/list/搜索.png" style="width: 14px; height: 14px">
                <div style="color: #B2B2B2; font-size: 12px; margin-left: 5px" class="">请输入搜索关键词</div>
            </div>
            <div class="filter-button flex flex-main-center flex-cross-center"
                 :class="{'filter-button-normal': selectedTypes.length == 0 && statusCd.length == 0, 'filter-button-selected': selectedTypes.length > 0 || statusCd.length > 0}"
                 @click="showFilter = true">
                <span>筛选</span>
            </div>
            <div v-if="sort.queryType === 1 || sort.queryType === 2 " class="filter-button flex flex-main-center flex-cross-center"
                 :class="{'filter-button-normal': selectedTypes.length == 0 && statusCd.length == 0, 'filter-button-selected': selectedTypes.length > 0 || statusCd.length > 0}"
                 @click="updSort">
                <span>
                    {{sort.type === 'DESC' ? `正序` : `倒序`}}
                    <van-icon :name='sort.arrow' color="#999"/>
                </span>
            </div>
        </div>
        <div v-if="statusCd.length > 0 || selectedTypes.length > 0 || searchText" class="search-tag-layout">
            <span v-for="(filter, i) in statusCd"
                  class="search-tag"
                  :key="i" @click="removeStatus(i)">
                    <div class="search-tag-txt">{{filter.text}}</div>
                    <img src="../../assets/img/list/关闭.png" class="search-tag-img"/>
            </span>
            <span v-for="(filter, i) in selectedTypes"
                  class="search-tag"
                  :key="i" @click="removeType(i)">
                    <div class="search-tag-txt">{{filter.approveName}}</div>
                    <img src="../../assets/img/list/关闭.png" class="search-tag-img"/>
            </span>
            <span v-if="searchText"
                  class="search-tag" @click="clearSearch">
                <div class="search-tag-txt">{{searchText}}</div>
                    <img src="../../assets/img/list/关闭.png" class="search-tag-img"/>
            </span>
        </div>
        <van-popup
            style="max-height: 100vh; width: 100vw"
            v-model="showSearch"
            @click-overlay="cancelSearch"
            position="top">
            <div style="background-color: white;">
                <van-search v-model="tempSearchText"
                            ref="searchEdit"
                            placeholder="请输入搜索关键词"
                            show-action>
                    <div
                        slot="action"
                        @click="confirmSearch"
                        style="color: #3388ff">搜索
                    </div>
                </van-search>
            </div>
        </van-popup>
        <van-popup
            v-model="showFilter"
            :lock-scroll="true"
            get-container="body"
            @click-overlay="cancelFilter"
            position="bottom">
            <div style="min-height: 100vh; text-align: left; background-color: #f3f4f8;">
                <div style="padding: 15px 0; ">
                    <div style=" padding: 0 13px;   height: calc(100vh - 1.6rem); overflow: auto;">
                        <div v-if="type!='1-0'" style="font-size: 15px; color: #999; margin-bottom: 10px">状态</div>
                        <van-row v-if="type!='1-0'">
                            <van-col v-for="(type, i) in statusArray"
                                     :key="i"
                                     :span="12">
                                <div style="margin: 0px 5px 10px 5px">
                                    <div class="filter-status flex flex-cross-center flex-main-center"
                                         @click="toggleStatus(type)"
                                         :class="{'filter-status-normal': isStatusSelected(type) < 0, 'filter-button-selected': isStatusSelected(type) >= 0}">
                                        <span>{{type.text}}</span>
                                    </div>
                                </div>
                            </van-col>
                        </van-row>
                        <div style="font-size: 15px; color: #999; margin-bottom: 10px; margin-top: 10px">类型</div>
                        <div class="filter-type">
                        <span v-for="(type, i) in typeList"
                              class="filter-type-text"
                              :class="{'filter-status-normal': isSelected(type) < 0, 'filter-button-selected': isSelected(type) >= 0}"
                              :key="i" @click="toggleType(type)">
                                {{type.approveName}}
                        </span>
                        </div>
                    </div>
                    <div class="flex filter-confirm">
                        <div class="flex-box-1 filter-confirm-button filter-confirm-button--cancel"
                             @click="cancelFilter">
                            取消
                        </div>
                        <div v-if="tempStatusCd.length > 0 || tempSelectedTypes.length > 0"
                             class="flex-box-1 filter-confirm-button filter-confirm-button--clear"
                             @click="clearFilter">
                            清空
                        </div>
                        <div class="flex-box-1 filter-confirm-button filter-confirm-button--confirm"
                             @click="confirmFilter">
                            确定
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>

    export default {
        components: {},
        name: 'approve-search-compnent',
        // mixins: [head],
        data() {
            return {
                showSearch: false,
                popupShow: false,
                searchText: '',
                tempSearchText: '',
                showFilter: false,
                time: '',
                typeList: [],
                selectedTypes: [],
                tempSelectedTypes: [],
                showStatus: false,
                statusCd: [],
                tempStatusCd: [],
                statusArray: [{
                    text: '审批中',
                    value: '1'
                }, {
                    text: '已同意',
                    value: '3'
                }, {
                    text: '已驳回',
                    value: '2'
                }, {
                    text: '已撤回',
                    value: '5'
                }],
                //排序
                sort: {
                  type: 'DESC', arrow: 'descending', queryType: undefined
                }
            };
        },
        props: {
            type: {
                default: ''
            }
        },
        watch: {
            '$route': 'routeChanged',
            'type': function () {
                this.inited();
            }
        },
        computed: {},
        created() {
            this.inited();
            this.routeChanged();
        },
        methods: {
            routeChanged() {
                if (this.$route.name == 'approve-list' && this.time != this.$route.query.time) {
                    this.time = _.cloneDeep(this.$route.query.time);
                    this.inited();
                    this.getData();
                }
            },
            inited() {
                //获取请求类型
                this.sort.queryType = this.$route.query.type;
                this.showSearch = false;
                this.searchText = '';
                this.tempSearchText = '';
                this.showFilter = false;
                this.selectedTypes = [];
                this.tempSelectedTypes = [];
                this.showStatus = false;
                this.statusCd = [];
                this.tempStatusCd = [];
                this.onChange();
            },

            getData() {
                let param = { groupType: '' };
                this.$http.post('badu/eaa/queryReadApproveList.do', param)
                    .then((response) => {
                        if (response.data && response.data.length > 0) {
                            this.initData(response.data);
                        }
                    });
            },

            initData(data) {
                this.typeList = [];
                for (let i = 0; i < data.length; i++) {
                    if (data[i].approveList && data[i].approveList.length > 0) {
                        this.typeList.push(...data[i].approveList);
                    }
                }
            },

            showSearchPop() {
                this.showSearch = true;
                // this.$nextTick(() => {
                //     this.$refs.searchEdit.$el.focus();
                // });
            },

            showPicker() {
                if (!this.picker) {
                    this.picker = this.$createPicker({
                        title: '状态',
                        data: [this.optionArray],
                        onSelect: (selectedVal, selectedIndex, selectedText) => {
                            this.cmpt.value = selectedText[0];
                        },
                        onCancel: () => {
                        }
                    });
                }
                this.picker.show();
            },

            toggleType(type) {
                console.log('toggleType', type);
                let exist = this.isSelected(type);
                console.log('toggleType--exist', exist);
                if (exist >= 0) {
                    this.tempSelectedTypes.splice(exist, 1);
                } else {
                    this.tempSelectedTypes.push(type);
                }
            },

            toggleStatus(status) {
                let exist = this.isStatusSelected(status);
                if (exist >= 0) {
                    this.tempStatusCd.splice(exist, 1);
                } else {
                    this.tempStatusCd.push(status);
                }
            },

            isSelected(type) {
                let exist = -1;
                for (let i = 0; i < this.tempSelectedTypes.length; i++) {
                    if (type.id == this.tempSelectedTypes[i].id) {
                        exist = i;
                        break;
                    }
                }
                return exist;
            },

            isStatusSelected(type) {
                let exist = -1;
                for (let i = 0; i < this.tempStatusCd.length; i++) {
                    if (type.value == this.tempStatusCd[i].value) {
                        exist = i;
                        break;
                    }
                }
                return exist;
            },

            removeStatus(i) {
                this.statusCd.splice(i, 1);
                this.tempStatusCd = [];
                this.tempStatusCd.push(...this.selectedTypes);
                this.onChange();
            },

            removeType(i) {
                this.selectedTypes.splice(i, 1);
                this.tempSelectedTypes = [];
                this.tempSelectedTypes.push(...this.selectedTypes);
                this.onChange();
            },

            cancelStatus() {
                this.showStatus = false;
                this.tempStatusCd = [];
                this.tempStatusCd.push(...this.statusCd);
            },

            confirmStatus() {
                this.showStatus = false;
                this.statusCd = [];
                this.statusCd.push(...this.tempStatusCd);
                this.onChange();
            },

            cancelFilter() {
                this.showFilter = false;
                this.tempSelectedTypes = [];
                this.tempSelectedTypes.push(...this.selectedTypes);
            },

            clearFilter() {
                // this.showFilter = false;
                // this.selectedTypes.splice(0, this.selectedTypes.length);
                // this.statusCd.splice(0, this.statusCd.length);
                this.tempSelectedTypes.splice(0, this.tempSelectedTypes.length);
                this.tempStatusCd.splice(0, this.tempStatusCd.length);
                // this.onChange();
            },

            confirmFilter() {
                this.showFilter = false;
                this.selectedTypes = [];
                this.selectedTypes.push(...this.tempSelectedTypes);
                this.statusCd = [];
                this.statusCd.push(...this.tempStatusCd);
                this.onChange();
            },

            cancelSearch() {
                this.showSearch = false;
                this.tempSearchText = this.searchText;
            },

            confirmSearch() {
                this.showSearch = false;
                this.searchText = this.tempSearchText;
                this.onChange();
            },

            clearSearch() {
                this.searchText = '';
                this.tempSearchText = '';
                this.onChange();
            },

            onChange() {
                this.$emit('onChange', this.statusCd, this.selectedTypes, this.searchText, this.sort.type);
            },
            updSort() {
                if (this.sort.type === 'DESC') {
                    this.sort.type = 'ASC';
                    this.sort.arrow = 'ascending';
                } else {
                    this.sort.type = 'DESC';
                    this.sort.arrow = 'descending';
                }
                this.confirmFilter();
            }
        }
    };
</script>

<style lang="scss" scoped>
    .list-search-layout {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 14px;
        padding: 6px 13px 0px 13px;
    }

    .list-search-search {
        flex: 1;
    }

    .filter-button {
        border-radius: 3px;
        height: 30px;
        font-size: 12px;
        margin-left: 10px;
        padding: 0px 14px 0px 14px;
    }

    .filter-button-normal {
        background-color: #fff;
        color: #999;
        border: 0px transparent solid;
    }

    .filter-button-selected {
        background-color: #ECF5FF;
        color: #3B9CFF;
        border: 1px #B3D8FF solid;
    }

    .filter-status {
        padding: 0px 5px 0px 5px;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        border-radius: 3px;
        min-height: 36px;
    }

    .filter-status-normal {
        background-color: #fff;
        color: #28405E;
        border: 0px transparent solid;
    }

    .filter-type {
        text-align: left;
        font-size: 14px;
        overflow: visible;

        .filter-type-text {
            display: inline-flex;
            flex-direction: row;
            align-items: center;
            width: auto;
            height: 36px;
            margin-top: 6px;
            margin-right: 8px;
            padding-left: 10px;
            padding-right: 10px;
            border-radius: 3px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 14px;
            line-height: 16px;
        }
    }

    .search-tag-layout {
        padding: 0px 13px 0px 13px;
        text-align: left;
        font-size: 12px;
        overflow: visible;
    }

    .search-tag {
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        width: auto;
        height: 27px;
        margin-top: 6px;
        margin-right: 8px;
        padding-left: 8px;
        padding-right: 8px;
        border-radius: 3px;
        overflow: hidden;
        background-color: #ECF5FF;
        color: #3B9CFF;
        border: 1px #B3D8FF solid;
    }

    .search-tag-img {
        width: 8px;
        height: 8px;
        margin-left: 8px;
    }

    .search-tag-txt {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        line-height: 14px;
    }

    .filter-confirm {
        position: fixed;
        left: 15px;
        bottom: 15px;
        right: 15px;

        .filter-confirm-button {
            height: 40px;
            border-radius: 3px;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
        }
        .filter-confirm-button--clear {
            color: white;
            background-color: #fc5c5d;
            margin-right: 10px;
        }
        .filter-confirm-button--cancel {
            color: #28405E;
            background-color: white;
            margin-right: 10px;
        }
        .filter-confirm-button--confirm {
            color: white;
            background-color: #07AFFA;
        }
    }
</style>
